import styled from '@emotion/styled';
import { Color } from '@diritto/common/style/color';
import { ContentBadge } from 'constants/badge';
import { AdultBoxIcon } from 'icons/AdultBoxIcon';
import { AdultRoundIcon } from 'icons/AdultRoundIcon';
import { DirittoRoundIcon } from 'icons/DirittoRoundIcon';
import { CompleteBadgeIcon } from 'icons/badge/CompleteBadgeIcon';
import { ContestBadgeIcon } from 'icons/badge/ContestBadgeIcon';
import { HiddenBadgeIcon } from 'icons/badge/HiddenBadgeIcon';
import { NewBadgeIcon } from 'icons/badge/NewBadgeIcon';
import { ProposalWantedBadgeIcon } from 'icons/badge/ProposalWantedBadgeIcon';
import { PublishedBadgeIcon } from 'icons/badge/PublishedBadgeIcon';
import { UpBadgeIcon } from 'icons/badge/UpBadgeIcon';

const COVER_ICON: Partial<Record<ContentBadge, React.ReactNode>> = {
  [ContentBadge.NEW]: <NewBadgeIcon />,
  [ContentBadge.ORIGINAL]: <DirittoRoundIcon color={Color.Primary500} className="size-[16px]" />,
  [ContentBadge.ONLY]: <DirittoRoundIcon color={Color.Green400} className="size-[16px]" />,
  [ContentBadge.UP]: <UpBadgeIcon />,
  [ContentBadge.COMPLETED]: <CompleteBadgeIcon />,
  [ContentBadge.PUBLISHED]: <PublishedBadgeIcon />,
  [ContentBadge.PICK_CHOOSE]: <ContestBadgeIcon />,
  [ContentBadge.ADULT]: <AdultRoundIcon className="size-[16px]" fillOpacity={0.6} />,
  [ContentBadge.HIDDEN]: (
    <div className="rounded-[2px] border-[0.5px] border-white/10 bg-gray-600 flex items-center justify-center">
      <HiddenBadgeIcon className="size-[16px]" color={Color.White} />
    </div>
  ),
  [ContentBadge.UNCONTRACTED]: <ProposalWantedBadgeIcon />,
};

const INLINE_ICON: Partial<Record<ContentBadge, React.ReactNode>> = {
  [ContentBadge.NEW]: <NewBadgeIcon />,
  [ContentBadge.ORIGINAL]: <DirittoRoundIcon color={Color.Primary500} className="size-[16px]" />,
  [ContentBadge.ONLY]: <DirittoRoundIcon color={Color.Green400} className="size-[16px]" />,
  [ContentBadge.UP]: <UpBadgeIcon />,
  [ContentBadge.COMPLETED]: <CompleteBadgeIcon />,
  [ContentBadge.PUBLISHED]: <PublishedBadgeIcon />,
  [ContentBadge.PICK_CHOOSE]: <ContestBadgeIcon />,
  [ContentBadge.ADULT]: <AdultBoxIcon className="size-[16px]" color={Color.Gray500} />,
  [ContentBadge.HIDDEN]: (
    <div className="rounded-[2px] border-[0.5px] border-white/10 bg-gray-600 flex items-center justify-center">
      <HiddenBadgeIcon className="size-[16px]" color={Color.White} />
    </div>
  ),
  [ContentBadge.UNCONTRACTED]: <ProposalWantedBadgeIcon />,
};

interface BadgeIconProps {
  type: ContentBadge;
  className?: string;
}

export const CoverBadgeIcon = ({ className, type }: BadgeIconProps) => (
  <StyledBadge className={className}>{COVER_ICON[type]}</StyledBadge>
);

export const InlineBadgeIcon = ({ className, type }: BadgeIconProps) => (
  <StyledBadge className={className}>{INLINE_ICON[type]}</StyledBadge>
);

const StyledBadge = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
